import React, { useId } from 'react';

interface LogoProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

/** A modular inventory block and flow arrow, independent of product category. */
export const Logo: React.FC<LogoProps> = ({ width = 40, height = 'auto', className = '', style = {} }) => {
  const gradient = useId();
  return (
    <svg width={width} height={height} viewBox="0 0 64 64" className={className}
      style={{ flexShrink: 0, ...style }} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="StockFlow">
      <defs>
        <linearGradient id={gradient} x1="16" y1="19" x2="45" y2="47" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1559b0" /><stop offset="1" stopColor="#124783" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="62" height="62" rx="18" fill="#f0f9ff" stroke="#fff" strokeWidth="2" />
      <path d="M32 9 49 19 32 29 15 19Z" fill="#278ac4" />
      <path d="M15 19 32 29v19L15 38Z" fill={`url(#${gradient})`} />
      <path d="M32 29 49 19v19L32 48Z" fill="#1686a0" />
      <path d="m15 19 17 10 17-10M32 29v19" fill="none" stroke="#f0f9ff" strokeWidth="2" strokeLinejoin="round" />
      <path d="M10 43c8 15 32 17 44 1m-7 1 7-1v7" fill="none" stroke="#f0f9ff" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 43c8 15 32 17 44 1m-7 1 7-1v7" fill="none" stroke="#0f766e" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default Logo;
